import { useQuery } from "@apollo/client";
import { useCallback } from "react";
import { useHistory } from "react-router";

import CancelConsult from "@components/CancelConsult";
import HandleQuery from "@components/HandleQuery";
import ExpertJourneyPage from "@components/pageTypes/ExpertJourneyPage";
import useSubscribeToConsult from "@hooks/subscriptions/useSubscribeToConsult";
import useSubscribeToJourney from "@hooks/subscriptions/useSubscribeToJourney";
import useMyExpert from "@hooks/useMyExpert";
import {
  GetConsultDocument,
  GetConsultQuery,
  GetConsultQueryVariables,
  GetJourneyWithExpertDocument,
  GetJourneyWithExpertQuery,
  GetJourneyWithExpertQueryVariables
} from "@typing/Generated";
import { journeyRoute } from "@utils/routeUtils";

type Props = {
  consultId: string;
  journeyId: string;
};

const ExpertJourneyCancelConsultPage = ({ consultId, journeyId }: Props) => {
  const history = useHistory();
  const myExpert = useMyExpert();

  const onSuccess = useCallback(() => {
    history.push(journeyRoute({ journeyId, linkAfterJourney: "/expert", myExpert }));
  }, [history, journeyId, myExpert]);

  const getJourneyQuery = useQuery<GetJourneyWithExpertQuery, GetJourneyWithExpertQueryVariables>(
    GetJourneyWithExpertDocument,
    {
      variables: { id: journeyId }
    }
  );

  useSubscribeToJourney(journeyId, () => {
    getJourneyQuery.refetch();
  });

  const getConsultQuery = useQuery<GetConsultQuery, GetConsultQueryVariables>(GetConsultDocument, {
    variables: { id: consultId }
  });

  useSubscribeToConsult(consultId, () => {
    getConsultQuery.refetch();
  });

  return (
    <ExpertJourneyPage helmetKey="pageTitles.expertJourney.consult.cancel" journeyId={journeyId}>
      <HandleQuery query={getJourneyQuery}>
        {journeyData => (
          <HandleQuery query={getConsultQuery}>
            {consultData => (
              <CancelConsult consult={consultData.consult} journey={journeyData.journey} onSuccess={onSuccess} />
            )}
          </HandleQuery>
        )}
      </HandleQuery>
    </ExpertJourneyPage>
  );
};

export default ExpertJourneyCancelConsultPage;
